import { isAllElementsOfSearchTextNotExist } from 'src/libs/utils'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (item[0] === 'client.clientId') {
        return [`client.id`, item[1]?.toLowerCase()]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export type ListRequest = {
  limit: number
  page: number
  orderBy: string
  orderDirection: string
  searchText: { [key: string]: string }
  filters?: {}
}

export const buildQuery = (params: ListRequest) => {
  let { limit, page, orderBy, orderDirection, searchText, filters } = params

  const normalizedOrderDirection = orderDirection === 'descend' ? '-' : ''

  const normalizedOrderBy =
    orderBy && orderBy.includes('country') ? 'client.country' : orderBy

  const query: Record<string, any> = { limit, page }

  if (normalizedOrderBy) {
    query['order'] = normalizedOrderDirection + normalizedOrderBy
  }

  let whereObj: Record<string, any> = {}

  if (filters && Object.keys(filters).length) {
    const arrayFields = ['taskType', 'prizeType']

    whereObj = Object.fromEntries(
      Object.entries(filters)
        .filter(([, value]) => value != null)
        .map(([key, value]) => {
          return [key, arrayFields.includes(key) ? value : String(value)]
        }),
    )
  }

  if (!isAllElementsOfSearchTextNotExist(searchText)) {
    whereObj = { ...whereObj, ...mapSearchText(searchText) }
  }

  if (Object.keys(whereObj).length !== 0) {
    query['where'] = JSON.stringify(whereObj)
  }

  return { query }
}
